/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export const POSITION = ({
  horizontal: 'horizontal',
  vertical: 'vertical'
} as const);
export const KIND = ({
  primary: 'primary',
  secondary: 'secondary'
} as const);